/**
 * Shared illustrated "Friends" HUD control.
 * The PNG already contains frame, character faces, parchment, and label text.
 */

export const FRIENDS_BUTTON_SRC = `${import.meta.env.BASE_URL}art/ui/friends.png`;

/**
 * Image-as-button — no chrome, text, or icons beyond the artwork.
 * Click handler is supplied by the host (opens shared character picker).
 */
export function createFriendsButton(options: {
  onActivate: () => void;
}): HTMLButtonElement {
  const button = document.createElement('button');
  button.type = 'button';
  button.className = 'wp-friends-btn';
  button.setAttribute('aria-label', 'Friends');

  const img = document.createElement('img');
  img.src = FRIENDS_BUTTON_SRC;
  img.alt = '';
  img.decoding = 'async';
  img.draggable = false;
  img.setAttribute('aria-hidden', 'true');
  button.append(img);

  button.addEventListener('click', (event) => {
    event.preventDefault();
    event.stopPropagation();
    options.onActivate();
  });

  return button;
}
